/// <amd-module name="Build/Admin/Agent/AgentView" />
import * as React from "react";

import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";
import { IVssPerformanceService } from "VSS/Platform/Performance";

import { AgentSignalRHub } from "Build/Admin/Agent/AgentSignalRHub";
import { AgentHub } from "Build/Admin/Agent/Components/AgentHub";
import { Flux } from "Build/Admin/Agent/Flux";
import { ServiceIds, Telemetry } from "Build/Admin/Common/Constants";
import { HeaderBreadcrumbService } from "Build/Admin/Common/Services/HeaderBreadcrumbService";
import { IProjectDataService } from "Build/Admin/Common/Services/ProjectDataService";

export class AgentView extends VssComponent<IVssComponentProperties> {
    private _flux: Flux;
    private _breadcrumbService: HeaderBreadcrumbService;
    private _signalRHub: AgentSignalRHub;
    private _ttiMarked: boolean = false;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._flux = new Flux(context.pageContext);
        this._flux.agentActionCreator.initializeAgentData();

        this.initializeSignalR(context);

        this._breadcrumbService = context.pageContext.getService<HeaderBreadcrumbService>(ServiceIds.HeaderBreadcrumbService);
        this._breadcrumbService.refresh({
            agentPool: this._flux.storesHub.selectionStore.state.selectedAgentPool,
            agentQueue: this._flux.storesHub.selectionStore.state.selectedAgentQueue,
            agent: this._flux.storesHub.selectionStore.state.selectedAgent
        });
    }

    public componentWillUnmount(): void {
        this._flux.dispose();
    }

    public componentDidMount(): void {
        if (!this._ttiMarked) {
            this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService").markTimeToInteractive(Telemetry.Area, Telemetry.AgentView);
            this._ttiMarked = true;
        }
    }

    public render(): JSX.Element {
        return (
            <AgentHub
                actionCreator={this._flux.agentActionCreator}
                storesHub={this._flux.storesHub} />
        );
    }

    private initializeSignalR(context: IVssComponentContext): void {
        const projectService = context.pageContext.getService<IProjectDataService>("IProjectDataService");
        const vssPageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const vssPageData = vssPageService.getData();

        if (vssPageData) {
            const projectData = projectService.getProjectData();

            const hostInformation = {
                hostId: vssPageData.hostId,
                isHosted: vssPageData.isHosted,
                hostPath: vssPageData.hostPath,
                projectId: projectData && projectData.id,
            };

            this._signalRHub = new AgentSignalRHub({
                hostInformation,
                actionCreator: this._flux.agentActionCreator,
                signalRActions: this._flux.actionsHub.signalRActions,
                pageContext: context.pageContext,
                removeApiPath: !projectData
            });

            if (this._flux.storesHub.selectionStore.state.selectedAgentQueue && this._flux.storesHub.selectionStore.state.selectedAgent) {
                this._signalRHub.listen(this._flux.storesHub.selectionStore.state.selectedAgentQueue.pool.id, this._flux.storesHub.selectionStore.state.selectedAgent.id);
            } else if (this._flux.storesHub.selectionStore.state.selectedAgentPool && this._flux.storesHub.selectionStore.state.selectedAgent) {
                this._signalRHub.listen(this._flux.storesHub.selectionStore.state.selectedAgentPool.id, this._flux.storesHub.selectionStore.state.selectedAgent.id);
            }
        }
    }
}

VssComponent.register("ms.vss-build-web.admin-agent-view-component", AgentView);
